import React from 'react';
import { useRouter } from 'next/router';
import ArtistsContainer from './artistContainer';
import ArtistsFilter from './artistFilters';

export default function ArtistsComponent() {
  const router = useRouter();

  const updateRoute = async (obj, type) => {
    let existingQueryParams = { ...router.query };

    if (type === 'remove') {
      if (existingQueryParams && existingQueryParams[obj[0]]) {
        delete existingQueryParams[obj[0]];
      }
      router.push({
        pathname: '/artists',
        query: { ...existingQueryParams },
      });
    } else if (type === 'removeFromArr') {
      console.log('remove from arr');
      if (Array.isArray(obj[1])) {
        console.log('is array');
        obj[1].map((ele, indx) => {
          existingQueryParams[obj[0]].splice(
            existingQueryParams[obj[0]].indexOf(ele),
            1,
          );
        });
      } else if (
        existingQueryParams &&
        existingQueryParams[obj[0]] &&
        existingQueryParams[obj[0]].includes(obj[1])
      ) {
        if (Array.isArray(existingQueryParams[obj[0]])) {
          existingQueryParams[obj[0]].splice(
            existingQueryParams[obj[0]].indexOf(obj[1]),
            1,
          );
        } else {
          delete existingQueryParams[obj[0]];
        }
      }
      router.push({
        pathname: '/artists',
        query: { ...existingQueryParams },
      });
    } else if (type === 'addToArr') {
      if (Array.isArray(obj[1])) {
        router.push({
          pathname: '/artists',
          query: { ...existingQueryParams, ...{ [obj[0]]: obj[1] } },
        });
      } else if (existingQueryParams && existingQueryParams[obj[0]]) {
        if (Array.isArray(existingQueryParams[obj[0]])) {
          existingQueryParams[obj[0]].push(obj[1]);
        } else {
          existingQueryParams[obj[0]] = [existingQueryParams[obj[0]], obj[1]];
        }
        router.push({
          pathname: '/artists',
          query: { ...existingQueryParams },
        });
      } else {
        router.push({
          pathname: '/artists',
          query: { ...existingQueryParams, ...{ [obj[0]]: obj[1] } },
        });
      }
    } else {
      //add new filter
      router.push({
        pathname: '/artists',
        query: { ...existingQueryParams, ...obj },
      });
    }
  };

  return (
    <>
      <main className="main center_container">
        <div className="container">
          <div className="row row--grid">
            <div className="w-full">
              <ul className="breadcrumb">
                <li className="breadcrumb__item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb__item breadcrumb__item--active">
                  MusicArtists
                </li>
              </ul>
            </div>

            <div className="w-full">
              <div className="main__title main__title--page px-4">
                <h1>MusicArtists</h1>
              </div>
            </div>

            <ArtistsFilter updateRoute={updateRoute} />
          </div>

          <ArtistsContainer />
        </div>
      </main>
    </>
  );
}
